import { c as _c } from "react/compiler-runtime";
import { ItemFileType, StoreImage, StoreImageEnum, getStoreImageHeight, getStoreImageWidth } from '@systemeio/digital-store-shared';
import { FileSourceEnum } from '@systemeio/file-manager';
import debounce from 'lodash.debounce';
import { FC, useEffect, useState } from 'react';
import { ImageUploader } from 'shared/components/file-uploader/image-uploader';
import { DataFile } from 'shared/types/datafile-type';
import { CloseIcon, UploadIcon } from '@systemeio/ui/icons';
interface StoreImageSelectorProps {
  imageType: StoreImageEnum;
  dataFile: ItemFileType | null;
  label: string;
  onChange: (dataFile: DataFile | null) => void;
}
const StoreImageSelector: FC<StoreImageSelectorProps> = t0 => {
  const $ = _c(30);
  const {
    onChange,
    dataFile,
    label,
    imageType
  } = t0;
  const [disabled, setDisabled] = useState(false);
  let t1;
  let t2;
  if ($[0] !== dataFile) {
    t1 = () => {
      if (dataFile) {
        setDisabled(true);
      }
    };
    t2 = [dataFile];
    $[0] = dataFile;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const width = getStoreImageWidth(imageType);
  const height = getStoreImageHeight(imageType);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = width / height;
  let t5;
  if ($[4] !== t4) {
    t5 = {
      imageCropperProps: {
        aspectRatio: t4
      }
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onChange) {
    t6 = dataFile_0 => {
      onChange(dataFile_0);
      setDisabled(true);
    };
    $[6] = onChange;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = dataFile?.name ?? imageType;
  const t8 = dataFile?.path;
  let t9;
  if ($[8] !== imageType || $[9] !== t7 || $[10] !== t8) {
    t9 = <StoreImage imageType={imageType} alt={t7} className="rounded-xl" src={t8} skipTheme={true} />;
    $[8] = imageType;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== dataFile || $[13] !== onChange) {
    t10 = dataFile && <button onClick={() => {
      onChange(null);
      debounce(() => setDisabled(false))();
    }} className="bg-brand-primary hover:bg-brand-primary-hover main-transition-colors pointer-events-auto absolute left-0 top-0 flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full p-1"><CloseIcon className="fill-background-secondary h-4 w-4" /></button>;
    $[12] = dataFile;
    $[13] = onChange;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <div className="[&>svg]:h-full [&>svg]:w-full relative">{t9}{t10}</div>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <UploadIcon />;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== label) {
    t13 = <div className="flex w-full flex-col items-center justify-center gap-1">{t12}{label}</div>;
    $[19] = label;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div />;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t11 || $[23] !== t13) {
    t15 = <div className="flex w-full flex-col items-center justify-center gap-3 sm:flex-row sm:justify-between">{t11}{t13}{t14}</div>;
    $[22] = t11;
    $[23] = t13;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== disabled || $[26] !== t15 || $[27] !== t5 || $[28] !== t6) {
    t16 = <><ImageUploader source={FileSourceEnum.DigitalStore} icon={t3} label="" labelClassName="hidden" imageCropperModalProps={t5} disabled={disabled} onSelect={t6}>{t15}</ImageUploader></>;
    $[25] = disabled;
    $[26] = t15;
    $[27] = t5;
    $[28] = t6;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};
export default StoreImageSelector;